// removed by extract-text-webpack-plugin
module.exports = {"totalBetContainer":"_2a8vywDRW2wMBCfO22G9To","valuesContainer":"_3DS_R1TXQscCMMoniBAlHv","totalBetText":"_9cBxaGJUCf_oKSHKOMgjN","totalBetValue":"HX06dglGI7LhBJ3yFl3uO"};


//////////////////
// WEBPACK FOOTER
// ./src/ui-modules/simplified/mobile/css/totalBets.css
// module id = 1022
// module chunks = 0